export const makeInactiveOnCondition = <T>(
  cond: boolean,
  fn: (t: T) => void
) => {
  return cond ? () => {} : fn;
};
